import { render, staticRenderFns } from "./addAnswer.vue?vue&type=template&id=d5f9c03c&scoped=true"
import script from "./addAnswer.vue?vue&type=script&lang=js"
export * from "./addAnswer.vue?vue&type=script&lang=js"
import style0 from "./addAnswer.vue?vue&type=style&index=0&id=d5f9c03c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f9c03c",
  null
  
)

export default component.exports